import * as React from 'react'
import { MinimalLayoutConnected } from './MinimalLayoutConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MinimalLayoutExamples = () => {
  return (
    <div className="MinimalLayoutExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MinimalLayoutConnected />
      </Provider>
    </div>
  )
}
